export enum TagType {
  Date = 'Date',
  Tags = 'Tags',
}
